var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.loading
            ? _c("loader")
            : _c("div", { staticClass: "modal-content wide" }, [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.getDataPrivacy()) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "modal-card-foot" }, [
                  _c("div", { staticClass: "level" }, [
                    _c("div", { staticClass: "level-left" }, [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "level-right" }, [
                      _c("button", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: _vm.langRoot + ".returnBtn",
                            expression: "`${langRoot}.returnBtn`"
                          }
                        ],
                        staticClass: "btn primary",
                        on: {
                          click: function($event) {
                            return _vm.$router.go(-1)
                          }
                        }
                      })
                    ])
                  ])
                ])
              ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13e9bc9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e9bc9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./shared/components/DataPrivacy.vue
// module id = 9hey
// module chunks = 0 1